import { _ as __rest } from './tslib.es6-DN65qNZS.js';
import React from 'react';
import classnames from 'classnames';
import { C as Content } from './Content-4xvXJbLn.js';

var styles = {"glimmer":"FXzzrJAf890-","reverseTheme":"s9bG0yRJR3A-","header":"M0X0dxjIyv4-","button":"v2Q1amzd7Ac-","buttonFill":"_8va--lBgr38-"};

var sizes = {"small":"siUUG4rZNSk-","base":"nFuBXyrhG2Q-","large":"oiVEoAqI-fU-","larger":"Tkmo6mSMI9Y-","largest":"uVeaD3IhD6o-","auto":"_6Wak9NLJ3VQ-"};

var shapes = {"rectangle":"enoWbteryXg-","rectangleShort":"_9qkwCdedX1M-","rectangleShorter":"XtyJxvcJDFs-","square":"_8unQ0TS1He4-","circle":"ameRMYEKfss-"};

var timings = {"base":"hO0mZ6TeVko-","fast":"WXi5-zF8Ll4-"};

const GLIMMER_TEST_ID = "ATL-Glimmer";
const GLIMMER_HEADER_TEST_ID = "ATL-GlimmerHeader";
const GLIMMER_TEXT_TEST_ID = "ATL-GlimmerText";
const GLIMMER_BUTTON_TEST_ID = "ATL-GlimmerButton";
/**
 * **Experimental component! Use at your own risk.**
 *
 * Foundational component used to build loading states such as Skeleton UI
 *
 * @experimental
 */
function Glimmer({ size = "base", shape = "rectangle", timing = "base", reverseTheme = false, width, }) {
    const className = classnames(styles.glimmer, sizes[size], shapes[shape], timings[timing], { [styles.reverseTheme]: reverseTheme });
    return (React.createElement("div", { "aria-busy": "true", role: "status", className: className, "data-testid": GLIMMER_TEST_ID, style: { width } }));
}
Glimmer.Header = function GlimmerHeader(_a) {
    var { level = 3 } = _a, props = __rest(_a, ["level"]);
    const headerSize = {
        1: "largest",
        2: "larger",
        3: "large",
        4: "base",
        5: "small",
    };
    return (React.createElement("div", { className: styles.header, "data-testid": GLIMMER_HEADER_TEST_ID },
        React.createElement(Glimmer, Object.assign({ size: headerSize[level] }, props))));
};
Glimmer.Text = function GlimmerText(_a) {
    var { width, lines = 3 } = _a, props = __rest(_a, ["width", "lines"]);
    const children = [
        React.createElement(Glimmer, Object.assign({ key: "1", size: "small", shape: "rectangleShort" }, props)),
        React.createElement(Glimmer, Object.assign({ key: "2", size: "small" }, props)),
        React.createElement(Glimmer, Object.assign({ key: "3", size: "small", shape: "rectangleShorter" }, props)),
    ].slice(0, lines);
    return (React.createElement("div", { style: { width }, "data-testid": GLIMMER_TEXT_TEST_ID },
        React.createElement(Content, { spacing: "small" }, children)));
};
Glimmer.Button = function GlimmerButton(_a) {
    var { fullWidth = false } = _a, props = __rest(_a, ["fullWidth"]);
    const buttonClassNames = classnames(styles.button, {
        [styles.buttonFill]: fullWidth,
    });
    return (React.createElement("div", { className: buttonClassNames, "data-testid": GLIMMER_BUTTON_TEST_ID },
        React.createElement(Glimmer, Object.assign({}, props, { size: "auto" }))));
};

export { Glimmer as G, GLIMMER_TEST_ID as a };
